console.log("Call estimate api onclick");
window.onclick = function(event) 
{

}

const saveCartButton = document.getElementById("saveCartButton");
const saveCartDialog = document.getElementById("saveCartDialog");
const closeSaveCartDialog = document.getElementById("closeSaveCartDialog");
const sendCartEmail = document.getElementById("sendCartEmail");
const saveCartMessage = document.getElementById("saveCartMessage");

saveCartButton?.addEventListener("click", () => {
  saveCartDialog.style.display = "flex";
});

closeSaveCartDialog?.addEventListener("click", () => {
  saveCartDialog.style.display = "none";
});

sendCartEmail?.addEventListener("click", async () => {
  try {
    const email = document.getElementById("saveCartEmail").value.trim();
    const phone = document.getElementById("saveCartNo").value.trim();

    if (!email) {
      saveCartMessage.innerText = "Please enter your email.";
      return;
    }

    saveCartMessage.innerText = "Sending...";

    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    const res = await fetch("https://estimates.rockin-rhino.co.uk/api/send-cart-link", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        email,
        phone,
        cart
      })
    });
    const data = await res.json();

    if (data.done) {
      saveCartMessage.innerText = "Cart link sent.";
    } else {
      saveCartMessage.innerText = "Failed to send cart link.";
    }

  } catch (err) {
    console.error(err);
    saveCartMessage.innerText = "Error sending cart link.";
  }
});



$(document).on('click', '#estimate', function (e)
{
  e.preventDefault();
  console.log("Call api here");
  //var email = prompt('Please enter your email');

  // Get the modal
  var modal = document.getElementById("myModal");

  var span = document.getElementsByClassName("close")[0];
  modal.style.display = "block";

  // When the user clicks on <span> (x), close the modal
  span.onclick = function() {
    modal.style.display = "none";
  }
})

let loginForm = document.getElementById("frmSubmit");

loginForm.addEventListener("submit", async (e) => {
  e.preventDefault();

  const errorContent = document.getElementById("errorContent");
  errorContent.innerHTML = "";

  try {
    const formData = new FormData(loginForm);

    const payloadForm = {
      email: formData.get("Email") || "",
      contactNo: formData.get("ContactNo") || "",
      customerRef: formData.get("Customerref") || "",
      address1: formData.get("Address") || "",
      address2: formData.get("Appartment") || "",
      city: formData.get("City") || "",
      postcode: formData.get("Postcode") || ""
    };

    // Read current Shopify cart
    const cart = await fetch("/cart.js").then(r => r.json());

    // Build one payload for your backend
    const payload = {
      customer: payloadForm,
      cart: {
        token: cart.token,
        note: cart.note || "",
        attributes: cart.attributes || {},
        currency: cart.currency,
        items: (cart.items || []).map(item => ({
          variantId: item.variant_id,
          quantity: item.quantity,
          title: item.product_title,
          sku: item.sku || "",
          handle: item.handle,
          price: item.final_price
        }))
      }
    };

    // Your existing estimate email API
    const estimateResponse = await fetch("https://estimates.rockin-rhino.co.uk/api/estimate", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...cart,
        useremail: payloadForm.email,
        customerref: payloadForm.customerRef,
        ContactNo: payloadForm.ContactNo,
        postcode: payloadForm.postcode,
        contactNo: payloadForm.contactNo,
        address1: payloadForm.address1,
        address2: payloadForm.address2,
        city: payloadForm.city
      })
    });

    if (!estimateResponse.ok) {
      throw new Error("Estimate email request failed");
    }

    // New draft-order API on your server
    const draftResponse = await fetch("https://estimates.rockin-rhino.co.uk/api/draft-order", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    const draftJson = await draftResponse.json();

    if (!draftResponse.ok) {
      throw new Error(draftJson.error || "Draft order creation failed");
    }

    console.log("Draft order created:", draftJson);

    var modal = document.getElementById("myModal");
    modal.style.display = "none";

    // Optional success message
    errorContent.innerHTML = "<p style='color: #04AA6D;'>Estimate sent and draft order created.</p>";
  } catch (error) {
    console.error(error);
    errorContent.innerHTML = "<p>" + error.message + "</p>";
  }
});
